import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { LoopsApi } from '@/lib/api/item-store/loops';
import { useOrgId } from '@/lib/hooks/common/useOrgId';
import { commonQueryKeys } from '@/lib/query-keys/common';
import { associateById } from '@/lib/utils/common/associateById';

export const getLoopsQueryOptions = (orgId: string) => ({
  queryKey: commonQueryKeys.loops.all(orgId),
  queryFn: () => LoopsApi.getLoops(),
});

export const useLoopsQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const orgId = useOrgId();
  return useQuery({
    ...getLoopsQueryOptions(orgId),
    enabled,
  });
};

export const useGetLoopsByIdQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const orgId = useOrgId();
  return useQuery({
    ...getLoopsQueryOptions(orgId),
    enabled,
    select: (data) => associateById(data.data),
  });
};

export const getLoopQueryOptions = ({ loopId }: { loopId: number }) =>
  queryOptions({
    queryKey: commonQueryKeys.loops.detail({ loopId }),
    queryFn: () => LoopsApi.getLoop({ loopId }),
  });

export const useGetLoopSuspenseQuery = ({ loopId }: { loopId: number }) =>
  useSuspenseQuery(getLoopQueryOptions({ loopId }));

export const useGetLoopQuery = ({
  loopId,
  enabled = true,
}: {
  loopId: number;
  enabled?: boolean;
}) =>
  useQuery({
    ...getLoopQueryOptions({ loopId }),
    enabled,
  });
